import { useEffect } from 'react';

const printConsole = () => {
  const version = import.meta.env.VITE_VERSION ? import.meta.env.VITE_VERSION.toString() : 'Unknown version';

  // Generated with: https://patorjk.com/software/taag/#p=display&f=Colossal&t=AP+Events&x=none&v=4&h=4&w=80&we=false
  const message1 = `
       d8888 8888888b.       8888888888                           888             
      d88888 888   Y88b      888                                  888             
     d88P888 888    888      888                                  888             
    d88P 888 888   d88P      8888888   888  888  .d88b.  88888b.  888888 .d8888b  
   d88P  888 8888888P"       888       888  888 d8P  Y8b 888 "88b 888    88K      
  d88P   888 888             888       Y88  88P 88888888 888  888 888    "Y8888b. 
 d8888888888 888             888        Y8bd8P  Y8b.     888  888 Y88b.       X88 
d88P     888 888             8888888888  Y88P    "Y8888  888  888  "Y888  88888P'\n`;

  const message2 = `Version ${version}`;
  const message3 = 'Made with love in 🇨🇭 Le Brassus by Audemars Piguet\n';

  console.log(`%c ${message1}`, 'font-size: 7px; font-weight: bold;');
  console.log(`%c${message2}`, 'font-weight: bold;');
  console.log(`%c${message3}`, 'font-weight: normal;');
};

function AppConsole() {
  useEffect(() => {
    console.clear();
    printConsole();
  }, []);

  return null;
}

export default AppConsole;
